import React, { useEffect } from "react";
import styles from "../mobileAppSection/mobileAppSection.module.scss";
import MobileApp from "../../components/mobileApp/MobileApp";
import EasySteps from "../../components/easySteps/EasySteps";
import ServicesProvided from "../../components/reusable/servicesProvided/ServicesProvided";
import CommonQuestions from "../../components/commonQuestions/CommonQuestions";
import Contact from "../../components/contact/Contact";
import Footer from "../footer/Footer";
import Navbar from "../../components/navbar/Navbar";

const data = [
  {id:1, question:"What is required to create a Play Store or App Store account?", answer: "A Play Store account requires a Google Developer account, while an App Store account needs an Apple Developer account."},
  {id:2, question:"What is a DUNS number, and why do I need it for the App Store?", answer: "A domain give A DUNS number is a unique identifier required for registering an organization on the Apple Developer Program."},
  {id:3, question:"How long does it take to publish an app?", answer: "Play Store approvals usually take a few hours to a day, while App Store reviews can take 24-48 hours or more."},
  {id:4, question:"What are the fees for developer accounts?", answer: "The Google Developer account costs a one-time $25 fee, while the Apple Developer account costs $99 per year."},
]


const MobileAppSection = () => {

  
  useEffect(() => {
    const section = document.getElementById("services");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []); 
  
  return (
    <div className={styles.container}>
      <Navbar/>
      <MobileApp id='services'/>
      <ServicesProvided/>
      <EasySteps/>
      <CommonQuestions questioData={data}/>
      <Contact/>
      <Footer/>
    </div>
  );
};

export default MobileAppSection;
